import config from '@feature-config/productivity/tasks/feature.config.json';
import { createFeatureModule } from '../../createFeatureModule';
import type { FeatureModule } from '../../types';
import { TaskManagementFeature } from './TaskManagementFeature';

const taskManagementFeature: FeatureModule = createFeatureModule(
  config,
  TaskManagementFeature,
  'productivity/tasks'
);

export default taskManagementFeature;
